<div class="stepper-container">
  <div class="steps-sidebar slider">
    <div class="sidebar-header mb-[24px] py-[24px] px-[16px] w-full flex items-center justify-between">
      <app-auto-registration-top-bar
        [logoWidth]="132"
        [mobileLogoWidth]="110"
        (watchVideo)="onOpenVideo()"
      ></app-auto-registration-top-bar>
    </div>
    <div class="sidebar-logo-bar">
      <app-auto-registration-top-bar
        [logoWidth]="190"
        [mobileLogoWidth]="140"
        [showActions]="false"
        (watchVideo)="onOpenVideo()"
      ></app-auto-registration-top-bar>
    </div>
    <main>
      <mat-stepper orientation="vertical" [linear]="false" #stepper [selectedIndex]="selectedIndex">
        <!-- Override Completed Icon -->
        <ng-template matStepperIcon="edit">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="18" viewBox="0 0 23 18" fill="none">
            <path d="M2 10.1667L7.9375 16L21 2" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </ng-template>

        <!-- Step 1: Basic Details -->
        <mat-step 
          [label]="'BASIC_DETAILS' | translate"
          [completed]="isStepCompleted(0)">
        </mat-step>

        <!-- Step 2: Business Details -->
        <mat-step 
          [label]="'BUSINESS_DETAILS' | translate"
          [completed]="isStepCompleted(1)">
        </mat-step>

        <!-- Step 3: Working Hours -->
        <mat-step 
          [label]="'WORKING_HOUR' | translate"
          [completed]="isStepCompleted(2)">
        </mat-step>
      </mat-stepper>
    </main>
  </div>
  
  <div class="step-content-area">
    <div class="watch-video-desktop">
      <app-auto-registration-top-bar
        [showLogo]="false"
        (watchVideo)="onOpenVideo()"
      ></app-auto-registration-top-bar>
    </div>

    <div class="step-content-wrapper">
      <div class="fields-container">
        <ng-container [ngSwitch]="selectedIndex">
          <app-basic-details-step
            *ngSwitchCase="0"
            (next)="onBasicDetailsNext()"
          ></app-basic-details-step>
          <app-business-details-step
            *ngSwitchCase="1"
            [isFromPrevious]="isBusinessDetailsFromPrevious"
            (next)="onBusinessDetailsNext()"
            (previous)="onBusinessDetailsPrevious()"
          ></app-business-details-step>
          <app-working-hours-step
            *ngSwitchCase="2"
            (previous)="onWorkingHoursPrevious()"
          ></app-working-hours-step>
        </ng-container>
      </div>
    </div>
  </div>
</div>
